import jexl from 'jexl';
import {UpdateFormStoreToolbarAction} from 'sulu-admin-bundle/views/Form';

export default class PERSPEQTIVEUpdateFormStoreToolbarAction extends UpdateFormStoreToolbarAction {
    getToolbarItemConfig() {
        const {
            visible_condition: visibleCondition,
        } = this.options;

        const visibleConditionFulfilled = !visibleCondition || jexl.evalSync(visibleCondition, this.conditionData);

        if (!visibleConditionFulfilled) {
            return;
        }

        return super.getToolbarItemConfig();
    }
}
